import React, { useEffect } from 'react';
import AppFooter from '../AppLayout/components/AppFooter';
import AppErrorBoundary from '../AppErrorBoundary';
import {useAuthUser} from '../../utility/AuthHooks';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import AppContentViewWrapper from './AppContentViewWrapper';
import EscortPendingBanner from './EscortPendingBanner';
import AppSuspense from '../AppSuspense';
import {Navigate, Route, Routes, useRoutes, useLocation} from 'react-router-dom';
import generateRoutes from '../../utility/RouteGenerator';
import {
  anonymousStructure,
  authorizedStructure,
  unAuthorizedStructure,
} from '../../../pages';
import {initialUrl} from 'shared/constants/AppConst';
import axios from 'axios';
import Api from '@api';
const AppContentView = ({sxStyle}) => {

// useEffect(() => {
//   axios.get(
//       Api.baseUri + '/api/gps-devices/trip-started?tripId=testTrip',
//     )
//     .then((response) =>{
//       if(response?.status==200){}
//     })
//     .catch((error) => console.error(error));
// }, []);
  const location = useLocation();
  const {user, isAuthenticated} = useAuthUser();
  const routes = useRoutes(
    generateRoutes({
      isAuthenticated: isAuthenticated,
      userRole: user?.role,
      unAuthorizedStructure,
      authorizedStructure,
      anonymousStructure,
    }),
  );
  return (
    <AppContentViewWrapper>
      {/* Above the padded content box rather than inside it: that padding is the page's
          own gutter, and a banner inside it becomes something every page's first element
          has to allow for. Mounted here because this is the one component all eleven
          layouts render, so the banner cannot go missing on a different navStyle. */}
      {isAuthenticated && <EscortPendingBanner />}
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          padding: '20px',

          ...sxStyle,
        }}
        className='app-content'
      >
        <AppSuspense>
          <AppErrorBoundary key={location.pathname}>
            {routes}
            <Routes>
              <Route path='/' element={<Navigate to={initialUrl} />} />
            </Routes>
          </AppErrorBoundary>
        </AppSuspense>
      </Box>
      <AppFooter />
    </AppContentViewWrapper>
  );
};

export default AppContentView;

AppContentView.propTypes = {
  sxStyle: PropTypes.object,
};
